import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tog-table-body',
  templateUrl: './table-body.component.html',
  styleUrls: ['./table-body.component.scss']
})
export class TableBodyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/table/table-body/table-body.component.ts